// extracted by mini-css-extract-plugin
module.exports = {"root":"item-list_root__mZu9e","subList":"item-list_subList__pgvng","columns":"item-list_columns__Q4_IN"};